import { FC } from 'react'
import { useSelector } from 'react-redux'

import { hasAccessToThis } from 'services/Utilities'
import { FiltersButton, HeroFilter, SavedPresets, FilterSummary } from '.'
import DateFilterButton from './DateFilterButton'
import SearchButton from './SearchButton'
import { MFilters } from 'types/filterTypes'
import { useLimitToReportsTo, useEmployeeNumberQueryParam, useSynchronisePunchFilters } from './hooks'
import { Badge } from 'ui'

import { t } from 'translations'

type FilterBarProps = {
  contentName: MFilters.ContentTypes
  options?: string[]
  heroFilters?: string[]
  withDate?: boolean
  withTime?: boolean
  isSingleDate?: boolean
  withoutSearchButton?: boolean
  hasPayPeriodsFilters?: boolean
}

const FilterBar: FC<FilterBarProps> = props => {
  const { contentName, options, heroFilters, withDate, withTime, isSingleDate, withoutSearchButton, hasPayPeriodsFilters } = props
  const settings = useSelector((state: MStore.RootState) => state.settings)
  useEmployeeNumberQueryParam(contentName)
  useSynchronisePunchFilters(contentName)

  const { isLargeCompany } = settings
  const limitToReportsTo = !!hasAccessToThis('limitToReportsTo')

  const { filteredOptions, filteredHeroFilters } = useLimitToReportsTo(contentName, limitToReportsTo, options, heroFilters)

  return (
    <div>
      <div className="d-flex flex-md-row ">
        {/* Show an indication that the user is limited to his projects or teams */}
        {limitToReportsTo ? (
          <Badge variant="secondary" className={`d-flex flex-row align-items-center mr-1 px-2`}>
            <i className={`fas fa-user  mr-1`} />
            {t(`searchBar.REPORTS_TO_ME`)}
          </Badge>
        ) : null}
        {withDate ? (
          <DateFilterButton withTime={withTime} isSingleDate={isSingleDate} hasPayPeriodsFilters={hasPayPeriodsFilters} contentName={contentName} />
        ) : null}

        {filteredHeroFilters?.map(heroFilter => (
          <div key={heroFilter} className="d-lg-flex d-none">
            <HeroFilter name={heroFilter} contentName={contentName} />
          </div>
        ))}
        {/* Button with all filters */}
        <FiltersButton filters={filteredOptions} contentName={contentName} />
        <SavedPresets contentName={contentName} />
        {isLargeCompany && !withoutSearchButton ? <SearchButton contentName={contentName} /> : null}
      </div>
      <div>
        <FilterSummary contentName={contentName} filters={filteredOptions} />
      </div>
    </div>
  )
}

export default FilterBar
